import React, { Component } from 'react';
import { Card ,Tooltip} from 'antd';
import s from './style.m.less';
import withRouter from '@/components/withRouter';
import theme_bg from '@/assets/images/wcb/theme_bg.webp';
import sub_org_logo from '@/assets/images/wcb/sub_org_logo.webp';
import ImageRender from '@/components/GrtImage/ImageRender';
class Sign extends Component {
    async componentDidMount() {
    }

    render() {
        return (
            <div className={s.competition_app}>
                <div style={{display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '1200px' }}>
                        <div className={s.org_logo}>
                            <ImageRender src={sub_org_logo} style={{height:'66px'}}/>
                        </div>
                        <div className={s.competition_content}>
                            <div style={{display:'flex',justifyContent:'center'}}>
                                <div className={s.left_wrap}>
                                    <div className={s.logo_wrap}>
                                        <ImageRender src={theme_bg} alt=''/>
                                    </div>
                                    <div className={s.handler_wrap}>
                                        <a className={s.btn} rel="noreferrer"
                                            href='https://apaas.grtcloud.net/preview/onlinePreview?url=aHR0cHM6Ly90dGNkdzYtb3Blbi5vYnMuY24tbm9ydGgtNC5teWh1YXdlaWNsb3VkLmNvbS8xNzcwNzY4NTk2NDk0MDEyNDE3LzBmZjVhODRiMGMzNjRjOWQyMjIyNjg2OGQxMTBiMDM3LnBkZg'
                                            target='_blank'>
                                            {'查看展演活动方案 >'}
                                        </a>
                                        <Tooltip title={'暂未开始'}>
                                            <a className={s.btn}>
                                                {'展演方案说明直播 >'}
                                            </a>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className={s.sign_right_wrap}>
                                    <Card hoverable>
                                        <div className={s['content-wrap']}>
                                            <div className={s['title-wrap']}>
                                                <div className={s['line1']}></div>
                                                <div className={s['tips']}>欢迎您的参与</div>
                                                <div className={s['line2']}></div>
                                            </div>
                                            <div className={s['info-wrap']}>
                                                <a className={s.sign_btn} href='https://www.bjteachers.cn/h/home/wcbzy/'>
                                                学校报名入口
                                                </a>
                                            </div>
                                        </div>
                                    </Card>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className={s.footer}>
                    <div
                        style={{
                            width: '1200px',
                            height: '92px',
                            margin: '0 auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <div className={s.footer_text}>
                            <div style={{ marginBottom: '8px' }}>
                                主办单位：北京教育学院人文与外语教育学院 <span style={{ marginLeft: '40px', display: 'inline-block' }}>教育戏剧研究中心</span>
                            </div>
                            <div>技术支持：北京国人通教育科技有限公司</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(Sign);